module.exports = __webpack_public_path__ + "static/media/Leaf.71da9d20.glb";